import AboutTwo from "../components/content/AboutTwo";
import FeaturesFive from "../components/features/FeaturesFive";
import FooterOne from "../components/footer/FooterOne";
import { Header } from "../components/header/Header";

const About = () => {
  return (
    <>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
      </div>
      <AboutTwo />
      <FeaturesFive />
      <FooterOne />
    </>
  );
};

export default About;
